// Horaires du salon
export const SALON_HOURS = {
    lundi: { open: '09:00', close: '19:00', closed: false },
    mardi: { open: '09:00', close: '19:00', closed: false },
    mercredi: { open: '09:00', close: '19:00', closed: false },
    jeudi: { open: '09:00', close: '19:00', closed: false },
    vendredi: { open: '09:00', close: '20:00', closed: false },
    samedi: { open: '10:00', close: '18:00', closed: false },
    dimanche: { open: null, close: null, closed: true },
};

// Durée des services (en minutes)
export const SERVICE_DURATION = {
    coupe: 30,
    coloration: 90,
    lissage: 120,
    extension: 120,
};

export const validationService = {
    // Vérifier si la date est valide
    isValidDate(dateString) {
        const selectedDate = new Date(dateString);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (selectedDate < today) {
            return false;
        }

        return true;
    },

    // Vérifier si le jour est ouvert
    isDayOpen(dateString) {
        const date = new Date(dateString);
        const dayName = date.toLocaleDateString('fr-FR', { weekday: 'long' }).toLowerCase();

        const dayHours = SALON_HOURS[dayName];

        if (!dayHours || dayHours.closed) {
            return false;
        }

        return true;
    },

    // Vérifier si l'heure est valide
    isValidTime(dateString, timeString, serviceId) {
        const date = new Date(dateString);
        const dayName = date.toLocaleDateString('fr-FR', { weekday: 'long' }).toLowerCase();
        const dayHours = SALON_HOURS[dayName];

        const [hours, minutes] = timeString.split(':').map(Number);
        const [openHours, openMinutes] = dayHours.open.split(':').map(Number);
        const [closeHours, closeMinutes] = dayHours.close.split(':').map(Number);

        const selectedTime = hours * 60 + minutes;
        const openTime = openHours * 60 + openMinutes;
        const closeTime = closeHours * 60 + closeMinutes;

        const serviceDuration = SERVICE_DURATION[serviceId] || 30;
        const endTime = selectedTime + serviceDuration;

        if (selectedTime < openTime) {
            return false;
        }

        if (endTime > closeTime) {
            return false;
        }

        return true;
    },

    // Vérifier les chevauchements
    async hasConflict(dateString, timeString, serviceId, existingReservations = []) {
        const [hours, minutes] = timeString.split(':').map(Number);
        const selectedTime = hours * 60 + minutes;
        const serviceDuration = SERVICE_DURATION[serviceId] || 30;
        const endTime = selectedTime + serviceDuration;

        for (const reservation of existingReservations) {
            // Vérifier si c'est le même jour
            if (reservation.date !== dateString) continue;

            // Vérifier si la réservation n'est pas annulée
            if (reservation.status === 'annulée') continue;

            const [resHours, resMinutes] = reservation.time.split(':').map(Number);
            const resStartTime = resHours * 60 + resMinutes;
            const resDuration = SERVICE_DURATION[reservation.service] || 30;
            const resEndTime = resStartTime + resDuration;

            // Vérifier le chevauchement
            if (selectedTime < resEndTime && endTime > resStartTime) {
                return true;
            }
        }

        return false;
    },

    // Valider une réservation complète
    async validateReservation(dateString, timeString, serviceId, existingReservations = []) {
        const errors = [];

        // Vérifier la date
        if (!this.isValidDate(dateString)) {
            errors.push('❌ La date doit être aujourd\'hui ou dans le futur');
        }

        // Vérifier si le salon est ouvert
        if (!this.isDayOpen(dateString)) {
            errors.push('❌ Le salon est fermé ce jour');
        }

        // Vérifier l'heure
        if (!this.isValidTime(dateString, timeString, serviceId)) {
            const dayName = new Date(dateString).toLocaleDateString('fr-FR', { weekday: 'long' }).toLowerCase();
            const dayHours = SALON_HOURS[dayName];
            errors.push(`❌ L'heure doit être entre ${dayHours.open} et ${dayHours.close}`);
        }

        // Vérifier les conflits
        const hasConflict = await this.hasConflict(dateString, timeString, serviceId, existingReservations);
        if (hasConflict) {
            errors.push('❌ Cette heure est déjà réservée');
        }

        return {
            isValid: errors.length === 0,
            errors,
        };
    },

    // Obtenir les heures disponibles pour un jour
    getAvailableHours(dateString, serviceId, existingReservations = []) {
        const date = new Date(dateString);
        const dayName = date.toLocaleDateString('fr-FR', { weekday: 'long' }).toLowerCase();
        const dayHours = SALON_HOURS[dayName];

        if (!dayHours || dayHours.closed) {
            return [];
        }

        const [openHours, openMinutes] = dayHours.open.split(':').map(Number);
        const [closeHours, closeMinutes] = dayHours.close.split(':').map(Number);

        const serviceDuration = SERVICE_DURATION[serviceId] || 30;
        const availableHours = [];

        let currentTime = openHours * 60 + openMinutes;
        const closeTime = closeHours * 60 + closeMinutes;

        while (currentTime + serviceDuration <= closeTime) {
            const hours = Math.floor(currentTime / 60);
            const minutes = currentTime % 60;
            const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

            // Vérifier s'il y a un conflit
            let hasConflict = false;
            for (const reservation of existingReservations) {
                if (reservation.date !== dateString || reservation.status === 'annulée') continue;

                const [resHours, resMinutes] = reservation.time.split(':').map(Number);
                const resStartTime = resHours * 60 + resMinutes;
                const resDuration = SERVICE_DURATION[reservation.service] || 30;
                const resEndTime = resStartTime + resDuration;

                if (currentTime < resEndTime && currentTime + serviceDuration > resStartTime) {
                    hasConflict = true;
                    break;
                }
            }

            if (!hasConflict) {
                availableHours.push(timeString);
            }

            currentTime += 30; // Incrémenter par 30 minutes
        }

        return availableHours;
    },
};
